<template>
    <path fill-rule="evenodd" d="M1904.5 3603.444L1901.393 3606.5 1904.5 3609.556 1903.545 3610.5 1899.5 3606.5 1903.545 3602.5z" transform="rotate(-90 -849 2753.5)"/>
</template>

<script>
export default {
    name: 'menuIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 8 5');
    }
}
</script>
